import { defineMessages } from 'react-intl';

type MessageKeys =
	| 'actionMessage'
	| 'pageSelectorLabel'
	| 'spaceSelectorLabel'
	| 'movePageButton'
	| 'confluencePageMoveActionCardTitle';

const message: Record<MessageKeys, { id: string; defaultMessage: string; description?: string }> =
	defineMessages({
		actionMessage: {
			id: 'ai-mate.message-actions.confluence-page-move.action-message',
			defaultMessage:
				"Here's the page I suggest moving to the target page. Take a look over it, then select <bold>Move Page</bold> when you're ready.",
			description:
				'Message text displayed in an action card within the AI conversation interface when the AI suggests moving a Confluence page to a different location. Shown as the main message text in the action card body. The <bold> tags will be rendered as bold text for "Move Page". The purpose is to present the page move suggestion to the user and provide clear instructions on how to proceed with moving the page to the target location.',
		},
		pageSelectorLabel: {
			id: 'ai-mate.message-actions.confluence-page-move.space-selector-label',
			defaultMessage: 'Parent page',
			description:
				'Label text displayed above or next to a page selector dropdown in the Confluence page move action card within the AI conversation interface. Shown as a form field label. The purpose is to identify the parent page selector control, which allows users to choose which Confluence page will serve as the new parent page for the page being moved.',
		},
		spaceSelectorLabel: {
			id: 'ai-mate.message-actions.confluence-page-move.space-selector-label',
			defaultMessage: 'Select a space',
			description:
				'Label text displayed above or next to a space selector dropdown in the Confluence page move action card within the AI conversation interface. Shown as a form field label. The purpose is to identify the space selector control, which allows users to choose which Confluence space the page will be moved to.',
		},
		movePageButton: {
			id: 'ai-mate.message-actions.confluence-page-move.move-page-button',
			defaultMessage: 'Move Page',
			description:
				'Button label displayed on the primary action button in the Confluence page move action card within the AI conversation interface. Shown as the text on a button at the bottom of the action card. When clicked, it moves the selected Confluence page to the target location (parent page or space). The purpose is to provide a clear call-to-action for users to confirm and execute the page move.',
		},
		confluencePageMoveActionCardTitle: {
			id: 'ai-mate.message-actions.confluence-page-move.action-card-title',
			defaultMessage: 'Move Page',
			description:
				'Title text displayed at the top of an action card in the AI conversation interface when the AI suggests moving a Confluence page to a different location. Shown as the card header title. The purpose is to immediately communicate to the user what action the card represents, which is moving an existing Confluence page to a new location.',
		},
	});

export default message;
